import FavoriteIcon from "@mui/icons-material/Favorite";
import { Box, CardContent, IconButton, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { appIcons } from "../../assets";
import Counter from "../counterButton";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { setCartData } from "../../lib/redux/slices/cartSlice";
import { useNavigate } from "react-router-dom";
import ShinyChip from "../shinyChip";
import { CURRENCY } from "../../lib/variables";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import "./style.css";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { t } from "i18next";

const deleteIconBtnStyle = {
  borderRadius: 0,
  padding: 0,
  height: 48,
  paddingX: 2,
  backgroundColor: "rgba(0, 0, 0, 0.04)",
};

const heartBtnStyle = {
  position: "absolute",
  top: 0,
  right: 0,
  border: `1px solid grey`,
};

const ProductCartCard = ({ product, index }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const isDiscount = product?.discount > 0 ? true : false;
  const productPrice =
    product?.discount > 0 ? product?.discount : product?.price;
  const [disableCounters, setDisAbleCounters] = useState({
    add: false,
    subtract: true,
  });

  const cartData = useSelector((state) => state.cartReducer.cartData);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const handleIncreaseQty = (product, index) => {
    let tempCart = [...cartData];

    if (product.quantity > 0) {
      if (product.selectedQty == product.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    if (product.size?.length > 0) {
      if (product.selectedQty == product.selectedSize.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    if (product.weigth?.length > 0) {
      if (product.selectedQty == product.selectedWeight.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    if (product.color?.length > 0) {
      if (product.selectedQty == product.selectedColor.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    if (product.sizeWithColor?.length > 0) {
      if (product.selectedQty == product.selectedSizeWithColor.quantity) {
        showSnackbar(t("maxQuantityReached"), "error");
        setDisAbleCounters({ ...disableCounters, add: true });
      } else {
        let updated = {
          ...tempCart[index],
          selectedQty: tempCart[index].selectedQty + 1,
        };
        tempCart[index] = updated;
      }
    }

    dispatch(setCartData(tempCart));
    localStorage.setItem("cart-data", JSON.stringify(tempCart));
  };

  const handleDecreaseQty = (product, ind) => {
    let tempCart = [...cartData];

    if (product.selectedQty === 1) {
      showSnackbar(t("minQuantityLimit"), "error");
      setDisAbleCounters({ ...disableCounters, subtract: false });
    } else {
      let updatedProduct = {
        ...tempCart[ind],
        selectedQty: tempCart[ind].selectedQty - 1,
      };
      tempCart[ind] = updatedProduct;
      dispatch(setCartData(tempCart));
      localStorage.setItem("cart-data", JSON.stringify(tempCart));
    }
  };

  const handleRemoveItem = (ind) => {
    let tempCart = [...cartData];
    tempCart.splice(ind, 1);
    dispatch(setCartData(tempCart));
    localStorage.setItem("cart-data", JSON.stringify(tempCart));
    showSnackbar(t("productRemovedFromCart"), "success");
  };

  return (
    <Box
      sx={{
        cursor: "pointer",
      }}
      onClick={() => navigate(`/product/${product.productUrl}`)}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        bgcolor={"text.lightGrey"}
        position={"relative"}
        gap={1}
        px={2}
        // pt={2}
        pb={5}
      >
        {product?.type === "Package" && <ShinyChip />}

        <Stack position={"relative"} mb={2}>
          {/* <IconButton
            sx={{
              ...heartBtnStyle,
            }}
          >
            <FavoriteIcon htmlColor="red" />
          </IconButton> */}
        </Stack>
        {/* <Box height={200}>
          <img
            src={product?.coverImage}
            height={"100%"}
            width={"100%"}
            loading="lazy"
            style={{
              objectFit: "contain",
            }}
          />
        </Box> */}

        <Box
          height={"220px"}
          width={"100%"}
          borderRadius={2}
          overflow={"hidden"}
          bgcolor="text.lightGrey"
          position={"relative"}
        >
          <Carousel
            showArrows
            infiniteLoop
            showIndicators={false}
            showStatus={false}
            showThumbs={false}
            renderArrowPrev={(clickHandler, hasPrev) => {
              return (
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    padding: "3px",
                    position: "absolute",
                    top: "40%",
                    left: "5px",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": {
                      boxShadow: 2,
                      backgroundColor: "#fff",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    clickHandler(e);
                  }}
                >
                  <KeyboardArrowLeft sx={{ fontSize: "20px" }} />
                </IconButton>
              );
            }}
            renderArrowNext={(clickHandler, hasNext) => {
              return (
                <IconButton
                  sx={{
                    border: "1px solid #ccc",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    padding: "3px",
                    position: "absolute",
                    top: "40%",
                    right: "5px",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    "&:hover": {
                      boxShadow: 2,
                      backgroundColor: "#fff",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    clickHandler(e);
                  }}
                >
                  <KeyboardArrowRight sx={{ fontSize: "20px" }} />
                </IconButton>
              );
            }}
          >
            {product?.images?.map((imageee) => {
              return (
                <img
                  src={imageee}
                  style={{
                    height: "220px",
                    aspectRatio: 16 / 9,
                    width: "100%",
                    objectFit: "cover",
                    loading: "lazy",
                  }}
                />
              );
            })}
          </Carousel>
          {/* <img
              src={cardData?.coverImage}
              alt={cardData.name}
              width="100%"
              height="100%"
              style={{ objectFit: "contain" }}
              loading="lazy"
            /> */}
        </Box>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Counter
            value={product?.selectedQty}
            handleDecreaseQty={(e) => {
              e.stopPropagation();
              handleDecreaseQty(product, index);
            }}
            handleIncreaseQty={(e) => {
              e.stopPropagation();
              handleIncreaseQty(product, index);
            }}
            // disbleCounters={disableCounters}
          />
          <IconButton
            sx={{ ...deleteIconBtnStyle }}
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveItem(index);
            }}
          >
            <img src={appIcons.deleteIcon} width={20} />
          </IconButton>
        </Stack>
        {/* only shows size and color and weight */}
        {product?.selectedColor && (
          <Stack
            direction={"row"}
            position={"absolute"}
            justifyContent={"center"}
            alignItems={"center"}
            left={0}
            right={0}
            bottom={8}
            gap={1}
          >
            <Typography>color :</Typography>
            <Box
              height={20}
              width={20}
              bgcolor={product?.selectedColor?.color}
              borderRadius={"100%"}
            ></Box>
          </Stack>
        )}
        {product?.selectedSize && (
          <Stack
            direction={"row"}
            position={"absolute"}
            justifyContent={"center"}
            alignItems={"center"}
            left={0}
            right={0}
            bottom={8}
            gap={1}
          >
            <Typography variant="body2">Size :</Typography>
            <Box
              px={1}
              py={0.2}
              height={20}
              width={"auto"}
              border={"1px solid"}
              borderColor={"text.borderGrey"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              borderRadius={1}
              fontSize={"0.875rem"}
            >
              {product?.selectedSize?.name}
            </Box>
          </Stack>
        )}
        {product?.selectedWeight && (
          <Stack
            direction={"row"}
            position={"absolute"}
            justifyContent={"center"}
            alignItems={"center"}
            left={0}
            right={0}
            bottom={8}
            gap={1}
          >
            <Typography variant="body2">Weight :</Typography>
            <Box
              px={1}
              py={0.2}
              height={20}
              width={"auto"}
              border={"1px solid"}
              borderColor={"text.borderGrey"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              borderRadius={1}
              fontSize={"0.875rem"}
            >
              {product?.selectedWeight?.name}
            </Box>
          </Stack>
        )}
        {product?.selectedSizeWithColor && (
          <Stack
            direction={"row"}
            position={"absolute"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={1}
            left={0}
            right={0}
            bottom={8}
          >
            <Typography>size :</Typography>

            <Box
              height={20}
              width={20}
              border={"1px solid"}
              borderColor={"text.borderGrey"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              borderRadius={1}
              fontSize={"0.875rem"}
            >
              {product?.selectedSizeWithColor?.size}
            </Box>
            <Typography ml={2}>color :</Typography>

            <Box
              height={20}
              width={20}
              bgcolor={product?.selectedSizeWithColor?.color}
              borderRadius={"100%"}
            ></Box>
          </Stack>
        )}
      </Box>
      <CardContent>
        <Typography
          variant="body1"
          fontWeight={500}
          textAlign={"center"}
          noWrap
        >
          {product?.name[currentLanguage]}
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={1}
          my={0.5}
        >
          <Typography fontSize="1.125rem" fontWeight={600}>
            {`${CURRENCY} ${productPrice}`}
          </Typography>
          {isDiscount && (
            <Typography
              fontSize="1rem"
              color="text.coolGrey"
              sx={{ textDecoration: "line-through" }}
            >
              {`${CURRENCY} ${product.price}`}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Box>
  );
};

export default ProductCartCard;
